// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogCard_cardGrid__QXNYJ {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2rem;
    background-color: #1a1a1a;
}

.BlogCard_card__t40J8 {
    background-color: #000;
    border-radius: 12px;
    overflow: hidden;
    transition: transform 0.2s;
}

.BlogCard_card__t40J8:hover {
    transform: translateY(-5px);
}
.BlogCard_noBlogsContainer__wcPll {
    text-align: center;
    padding: 2rem;
  }
  
  .BlogCard_noBlogs__swR99 {
    font-size: 1.2rem;
    color: #666;
  }
  .BlogCard_placeholderImage__HtNdq {
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    color: #666;
  }
  
  .BlogCard_avatarPlaceholder__HmsPK {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #666;
    margin-right: 8px;
  }

.BlogCard_imageContainer__8MqZR {
    position: relative;
    height: 200px;
}

.BlogCard_image__U5njR {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.BlogCard_category__vKmno {
    position: absolute;
    top: 1rem;
    left: 1rem;
    background-color: rgba(128, 128, 128, 0.8);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    text-decoration: none;
    font-weight: 500;
}

.BlogCard_content__i7Cu1 {
    padding: 1rem;
}

.BlogCard_title__bQdti {
    color: white;
   padding: 0px;
    margin: 0px;
}

.BlogCard_authorSection__IHwQw {
    display: none;
    justify-content: space-between;
    align-items: center;
    margin: 2px 0;
}

.BlogCard_author__9VqbF {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: white;
}

.BlogCard_avatar__NJCcy {
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.BlogCard_date__YbDel {
    color: #fff;
    font-size: 12px;
}

.BlogCard_description__L9P7e {
    color: #999;
    font-size: 0.95rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.BlogCard_viewPost__OFxZV {
    color: #ff0000;
    text-decoration: none;
    font-weight: 500;
    display: inline-block;
    cursor: pointer;
    padding-top: 10px;
}

.BlogCard_viewPost__OFxZV:hover {
    text-decoration: underline;
}

.BlogCard_loadMoreContainer__9YS5i {
    display: flex;
    justify-content: center;
    margin: 2rem 0;
    background-color: #1a1a1a;
    padding-bottom: 2rem;
}

.BlogCard_loadMoreButton__D\\+KJ- {
    background-color: transparent;
    color: white;
    border: 2px solid white;
    padding: 0.75rem 2.5rem;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease;
}

.BlogCard_loadMoreButton__D\\+KJ-:hover {
    background-color: white;
    color: #1a1a1a;
}

@media (max-width: 769px) {
    .BlogCard_title__bQdti {
        font-size: 1.25rem;
        margin: 0px;
        height: 26px;
    }
    
    .BlogCard_description__L9P7e {
        font-size: 0.8rem;
    }
}
@media (max-width: 480px) {
    .BlogCard_divider__a7Vlf {
        margin: 0.3rem 0;
    }
    .BlogCard_content__i7Cu1 {
        padding: 0rem;
    }
    .BlogCard_title__bQdti {
        font-size: 14px;
    }
    .BlogCard_imageContainer__8MqZR {
        height: 130px;
    }
    .BlogCard_cardGrid__QXNYJ {
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    }
    .BlogCard_category__vKmno{
        font-size: 10px;
        padding: 5px 5px;
        top: 5px;
        left: 5px;
    }
    .BlogCard_description__L9P7e{
        font-size: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Blogs/Components/CSS/BlogCard.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;EACnB;;AAEF;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,0CAA0C;IAC1C,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;GACb,YAAY;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,qCAAqC;QACrC,SAAS;IACb;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,QAAQ;QACR,SAAS;IACb;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".cardGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 2rem;\n    background-color: #1a1a1a;\n}\n\n.card {\n    background-color: #000;\n    border-radius: 12px;\n    overflow: hidden;\n    transition: transform 0.2s;\n}\n\n.card:hover {\n    transform: translateY(-5px);\n}\n.noBlogsContainer {\n    text-align: center;\n    padding: 2rem;\n  }\n  \n  .noBlogs {\n    font-size: 1.2rem;\n    color: #666;\n  }\n  .placeholderImage {\n    background-color: #f0f0f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 200px;\n    color: #666;\n  }\n  \n  .avatarPlaceholder {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background-color: #e0e0e0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    color: #666;\n    margin-right: 8px;\n  }\n\n.imageContainer {\n    position: relative;\n    height: 200px;\n}\n\n.image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.category {\n    position: absolute;\n    top: 1rem;\n    left: 1rem;\n    background-color: rgba(128, 128, 128, 0.8);\n    color: white;\n    padding: 0.5rem 1rem;\n    border-radius: 6px;\n    text-decoration: none;\n    font-weight: 500;\n}\n\n.content {\n    padding: 1rem;\n}\n\n.title {\n    color: white;\n   padding: 0px;\n    margin: 0px;\n}\n\n.authorSection {\n    display: none;\n    justify-content: space-between;\n    align-items: center;\n    margin: 2px 0;\n}\n\n.author {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    color: white;\n}\n\n.avatar {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n}\n\n.date {\n    color: #fff;\n    font-size: 12px;\n}\n\n.description {\n    color: #999;\n    font-size: 0.95rem;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.viewPost {\n    color: #ff0000;\n    text-decoration: none;\n    font-weight: 500;\n    display: inline-block;\n    cursor: pointer;\n    padding-top: 10px;\n}\n\n.viewPost:hover {\n    text-decoration: underline;\n}\n\n.loadMoreContainer {\n    display: flex;\n    justify-content: center;\n    margin: 2rem 0;\n    background-color: #1a1a1a;\n    padding-bottom: 2rem;\n}\n\n.loadMoreButton {\n    background-color: transparent;\n    color: white;\n    border: 2px solid white;\n    padding: 0.75rem 2.5rem;\n    border-radius: 4px;\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.loadMoreButton:hover {\n    background-color: white;\n    color: #1a1a1a;\n}\n\n@media (max-width: 769px) {\n    .title {\n        font-size: 1.25rem;\n        margin: 0px;\n        height: 26px;\n    }\n    \n    .description {\n        font-size: 0.8rem;\n    }\n}\n@media (max-width: 480px) {\n    .divider {\n        margin: 0.3rem 0;\n    }\n    .content {\n        padding: 0rem;\n    }\n    .title {\n        font-size: 14px;\n    }\n    .imageContainer {\n        height: 130px;\n    }\n    .cardGrid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 1rem;\n    }\n    .category{\n        font-size: 10px;\n        padding: 5px 5px;\n        top: 5px;\n        left: 5px;\n    }\n    .description{\n        font-size: 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardGrid": `BlogCard_cardGrid__QXNYJ`,
	"card": `BlogCard_card__t40J8`,
	"noBlogsContainer": `BlogCard_noBlogsContainer__wcPll`,
	"noBlogs": `BlogCard_noBlogs__swR99`,
	"placeholderImage": `BlogCard_placeholderImage__HtNdq`,
	"avatarPlaceholder": `BlogCard_avatarPlaceholder__HmsPK`,
	"imageContainer": `BlogCard_imageContainer__8MqZR`,
	"image": `BlogCard_image__U5njR`,
	"category": `BlogCard_category__vKmno`,
	"content": `BlogCard_content__i7Cu1`,
	"title": `BlogCard_title__bQdti`,
	"authorSection": `BlogCard_authorSection__IHwQw`,
	"author": `BlogCard_author__9VqbF`,
	"avatar": `BlogCard_avatar__NJCcy`,
	"date": `BlogCard_date__YbDel`,
	"description": `BlogCard_description__L9P7e`,
	"viewPost": `BlogCard_viewPost__OFxZV`,
	"loadMoreContainer": `BlogCard_loadMoreContainer__9YS5i`,
	"loadMoreButton": `BlogCard_loadMoreButton__D+KJ-`,
	"divider": `BlogCard_divider__a7Vlf`
};
export default ___CSS_LOADER_EXPORT___;
